import { trackProductFiltering } from './products'

export const filterProductCategory = (
  eventName, eventAction, eventType, primaryCategory, productsPerCategory,
  categoryId) => (
  (dispatch) => {
    dispatch({ type: 'FILTERS_PRODUCT_CATEGORY', value: categoryId })
    dispatch(
      trackProductFiltering(eventName, eventAction, eventType, primaryCategory, productsPerCategory),
    )
  }
)
